import {
    GET_PLANOGRAMS_PENDING,
    GET_PLANOGRAMS_FULFILLED,
    GET_PLANOGRAMS_REJECTED,
    UPLOAD_PLANOGRAM_PENDING,
    UPLOAD_PLANOGRAM_FULFILLED,
    UPLOAD_PLANOGRAM_REJECTED,
    DELETE_PLANOGRAM_PENDING,
    DELETE_PLANOGRAM_FULFILLED,
    DELETE_PLANOGRAM_REJECTED,
} from '../actions/PlanogramActions';

// INITIALIZE STATE
const initialState = {
    planograms: [],
    fetchingPlanograms: false,
    fetchedPlanograms: false,
    failedPlanograms: false,
    uploadingPlanogram: false,
    uploadedPlanogram: false,
    uploadPlanogramFailed: false,
    deletingPlanogram: false,
    deletedPlanogram: false,
    deletePlanogramFailed: false,
    error: ''
};

export const PlanogramReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_PLANOGRAMS_PENDING:
            return {
                ...state,
                fetchingPlanograms: true,
                fetchedPlanograms: false,
                failedPlanograms: false,
                error: ''
            };
        case GET_PLANOGRAMS_FULFILLED:
            
            return {
                ...state,
                planograms: action.payload,
                fetchingPlanograms: false,
                fetchedPlanograms: true,
                failedPlanograms: false,
            };
        case GET_PLANOGRAMS_REJECTED:
            return {
                ...state,
                fetchingPlanograms: false,
                fetchedPlanograms: false,
                failedPlanograms: true,
                error: action.payload
            };
        case UPLOAD_PLANOGRAM_PENDING:
            return {
                ...state,
                uploadingPlanogram: true,
                uploadedPlanogram: false,
                uploadPlanogramFailed: false
            };
        case UPLOAD_PLANOGRAM_FULFILLED:
            return {
                ...state,
                uploadingPlanogram: false,
                uploadedPlanogram: true,
                uploadPlanogramFailed: false
            };
        case UPLOAD_PLANOGRAM_REJECTED:
            return {
                ...state,
                uploadingPlanogram: false,
                uploadedPlanogram: false,
                uploadPlanogramFailed: true
            };
        case DELETE_PLANOGRAM_PENDING:
            return {
                ...state,
                deletingPlanogram: true,
                deletedPlanogram: false,
                deletePlanogramFailed: false
            };
        case DELETE_PLANOGRAM_FULFILLED: {
            let allplanograms = state.planograms.filter(item => item.id !== action.payload);
            return {
                ...state,
                planograms: allplanograms,
                deletingPlanogram: false,
                deletedPlanogram: true,
                deletePlanogramFailed: false
            };
        } 
        case DELETE_PLANOGRAM_REJECTED:
            return {
                ...state,
                deletingPlanogram: false,
                deletedPlanogram: false,
                deletePlanogramFailed: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/PlanogramReducer.js